import { render, staticRenderFns } from "./modal-profile-update-name.vue?vue&type=template&id=d98c7bec&scoped=true"
import script from "./modal-profile-update-name.vue?vue&type=script&lang=js"
export * from "./modal-profile-update-name.vue?vue&type=script&lang=js"
import style0 from "./modal-profile-update-name.vue?vue&type=style&index=0&id=d98c7bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c7bec",
  null
  
)

export default component.exports